import { CButton, CCol, CRow } from "@coreui/react";
import { formatSerialNumber, GeneratedRecordItem } from "../../models/generated-record";

import { defaultValueOnUndefined } from "../../utils/fields";

interface RecordDetailItemDataProps {
  recordItem?: GeneratedRecordItem;
  onGoBackClick: () => void | Promise<void>;
}

const RecordDetailItemData: React.FC<RecordDetailItemDataProps> = ({
  recordItem,
  onGoBackClick,
}) => {

  return (
    <>  
    <CRow><CCol><h3 style={{ color: "#004080" }}>Datos Generales del DUA</h3></CCol></CRow>
    <CRow >
      <CCol md={6} sm={12} className={"mt-5"}>
        <CRow><CCol sm={6} md={4}><strong>Número de Serie</strong></CCol><CCol sm={6}>{formatSerialNumber(recordItem?.serialNumber)}</CCol></CRow>
        <CRow><CCol sm={6} md={4}><strong>Peso Neto</strong></CCol><CCol sm={6}>{defaultValueOnUndefined("", recordItem?.netWeight)}</CCol></CRow>
        <CRow><CCol sm={6} md={4} ><strong>Peso Bruto</strong></CCol><CCol sm={6}>{defaultValueOnUndefined("", recordItem?.grossWeight)}</CCol></CRow>
        <CRow><CCol sm={6} md={4}><strong>Acuerdo</strong></CCol><CCol sm={6}>{defaultValueOnUndefined("", recordItem?.agreement)}</CCol></CRow>
        <CRow><CCol sm={6} md={4}><strong>Código Arancelario</strong></CCol><CCol sm={6}>{defaultValueOnUndefined("", recordItem?.tariffCode)}</CCol></CRow>
        <CRow><CCol sm={6} md={4}><strong>País de Origen</strong></CCol><CCol sm={6}>{defaultValueOnUndefined("", recordItem?.countryOfOrigin)}</CCol></CRow>
        <CRow><CCol sm={6} md={4}><strong>Cantidad Unidad Comercial</strong></CCol><CCol sm={6}>{defaultValueOnUndefined("", recordItem?.commercialUnitQuantity)}</CCol></CRow>
        <CRow><CCol sm={6} md={4}><strong>Valor Aduanas (U$S)</strong></CCol><CCol sm={6}>{defaultValueOnUndefined("", recordItem?.customsValueUsd)}</CCol></CRow>
      </CCol>
      <CCol md={6} sm={12} className={"mt-5"}>
        <CRow><CCol sm={6} md={4}><strong>Partida</strong></CCol><CCol sm={6}>{defaultValueOnUndefined("", recordItem?.shipment)}</CCol></CRow>
        <CRow><CCol sm={6} md={4}><strong>Tipo de Nomenclatura</strong></CCol><CCol sm={6}>{defaultValueOnUndefined("", recordItem?.nomenclatureType)}</CCol></CRow>
        <CRow><CCol sm={6} md={4}><strong>Código Producto dentro Acuerdo</strong></CCol><CCol sm={6}>{defaultValueOnUndefined("", recordItem?.productCodeWithinAgreement)}</CCol></CRow>
        <CRow><CCol sm={6} md={4}><strong>Exoneración (MNT-E)</strong></CCol><CCol sm={6}>{defaultValueOnUndefined("", recordItem?.exemptionMntE)}</CCol></CRow>
        <CRow><CCol sm={6} md={4}><strong>País de Procedencia</strong></CCol><CCol sm={6}>{defaultValueOnUndefined("", recordItem?.countryOfProvenance)}</CCol></CRow>
        <CRow><CCol sm={6} md={4}><strong>Cantidad UVF</strong></CCol><CCol sm={6}>{defaultValueOnUndefined("", recordItem?.uvfQuantity)}</CCol></CRow>
      </CCol>
    </CRow>
    <CRow className="mt-5 mb-5">
      <CCol className={"center-button"}>
        <CButton onClick={onGoBackClick} className="custom-button">
          Volver a Detalle DUA
        </CButton>
      </CCol>
    </CRow>
    <style>{`
      .custom-button {
        background-color: #004080; /* Color de fondo */
        border-color: #003676; /* Color del borde */
        color: white; /* Color del texto */
        text-align: center; /* Centra el texto */
      }

      .custom-button:hover {
        background-color: #002767; /* Color de fondo en hover */
        border-color: #002c6c; /* Color del borde en hover */
      }

      .center-button {
        display: flex;
        justify-content: center; /* Centra horizontalmente */
      }
    `}</style>
  </>
  );
};

export default RecordDetailItemData;
